import { createContext, useState, useMemo } from 'react';
import { generateCallTopics } from '../utils/callTopicUtils';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const CallTopicContext = /*#__PURE__*/createContext({});
export const CallTopicContextProvider = props => {
  const {
    children,
    transcriptUtterances,
    showCallTopics,
    setCurrentTime,
    durationInSeconds,
    onCallTopicsClick
  } = props;
  const [hoveredCallTopic, setHoveredCallTopic] = useState(null);
  const [selectedCallTopic, setSelectedCallTopic] = useState(null);
  const [currentTopicUtterance, setCurrentTopicUtterance] = useState(null);
  const callTopics = useMemo(() => {
    return generateCallTopics(transcriptUtterances, durationInSeconds);
  }, [durationInSeconds, transcriptUtterances]);

  // Gets all utterances that have a primary call topic that matches the currently selected one
  const selectedTopicUtterances = useMemo(() => {
    return callTopics.filter(callTopic => callTopic.callTopicId === selectedCallTopic);
  }, [callTopics, selectedCallTopic]);
  const handleSelectedCallTopicToggle = (callTopicId, callTopicInstance) => {
    if (onCallTopicsClick) {
      onCallTopicsClick();
    }
    if (callTopicInstance) {
      setSelectedCallTopic(callTopicId);
      setCurrentTime(callTopicInstance.startTimeSeconds);
    } else {
      if (selectedCallTopic === callTopicId) {
        // Topic already selected, deselect now
        setSelectedCallTopic(null);
      } else {
        setSelectedCallTopic(callTopicId);

        // Get the first utterance w/ the selected call topic and jump to that utterance
        const firstTopicUtterance = callTopics.find(utterance => utterance.callTopicId === callTopicId);
        if (firstTopicUtterance) {
          setCurrentTime(firstTopicUtterance.startTimeSeconds);
        }
      }
    }
  };
  const handleHoveredCallTopicToggle = callTopicId => {
    if (hoveredCallTopic === callTopicId) {
      setHoveredCallTopic(null);
    } else {
      setHoveredCallTopic(callTopicId);
    }
  };
  const selectedTopicUtteranceIndex = useMemo(() => {
    if (!currentTopicUtterance) return null;
    const index = selectedTopicUtterances.indexOf(currentTopicUtterance);
    return index !== -1 ? index : null;
  }, [currentTopicUtterance, selectedTopicUtterances]);
  const contextValue = {
    callTopics,
    hoveredCallTopic,
    selectedCallTopic,
    selectedTopicUtteranceIndex,
    currentTopicUtterance,
    selectedTopicUtterances,
    handleSelectedCallTopicToggle,
    handleHoveredCallTopicToggle,
    setCurrentTopicUtterance
  };
  if (!showCallTopics) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(CallTopicContext.Provider, {
    value: contextValue,
    children: children
  });
};